import { environment } from '../environments/environment';

export const settings = {
  API_URL: environment.API_URL,
};
